import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationSwathWidth
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectSwathWidth } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    swathWidth: CalibrationSwathWidth;
}

type Props = OwnProps & ConnectedProps;

export class SwathWidthTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { swathWidth } = this.props;

        return <TableCell>{swathWidth}m</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    swathWidth: makeSelectSwathWidth()
});

export default connect(mapStateToProps)(SwathWidthTableCellComponent);
